export interface CodeData { lineNumber: number; }

export type CodeRamMapping = Map<number, CodeData>;

export enum ByteType {
  OPCODE = 'OPCODE',
  OPERAND1 = 'OPERAND1',
  OPERAND2 = 'OPERAND2',
  DATA = 'DATA',
  EMPTY = 'EMPTY',
}

export interface ByteData {
  value: number;
  type: ByteType;
}

export enum CPUSpeed {

  _4Hz = 0,
  _16Hz = 1,
  _64Hz = 2,
  _256Hz = 3,
  _1kHz = 4,
  _4kHz = 5

}

export interface IPanelConfiguration {

  visible: boolean;
  size: number;

}

export interface IConfiguration {

  /* CPU Speed */
  cpuSpeed: number;

  ioRegistersPanel: IPanelConfiguration;
  memoryPanel: IPanelConfiguration;
  cpuRegistersPanel: IPanelConfiguration;
  ioDevicesPanel: IPanelConfiguration;
  codePanel: IPanelConfiguration;
  eventsLogPanel: IPanelConfiguration;

  rightBarVisible: boolean;
  easyMode: boolean;
  clearBytesAfterPop: boolean;
  followLineWhileRunning: boolean,
}
